import { requestWithToken } from '../../utilities/request';
const path = '/api/private/ccus';

/**
 * 現場に未登録の作業員のリストを取得する
 * @param fieldTreeId
 * @param param
 * @returns {Promise<*>}
 */
const getUnassignedWorker = (fieldTreeId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/field_trees/${fieldTreeId}/unassigned_workers`),
    params: param,
  });
};

/**
 * 現場に登録中の作業員のリストを取得する
 * @param fieldTreeId
 * @param param
 * @returns {Promise<*>}
 */
const getAssignedWorker = (fieldTreeId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/field_trees/${fieldTreeId}/assigned_workers`),
    params: param,
  });
};

/**
 * 作業員労務安全情報取得API
 * @param fieldId
 * @param fieldTreeWorkerId
 * @returns {Promise<*>}
 */
const fetchWorkerInfo = (fieldId, fieldTreeWorkerId) => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/fields/${fieldId}/field_tree_workers/${fieldTreeWorkerId}/worker_info`,
  });
};

/**
 * 作業員として現場に登録する
 * @param fieldId
 * @param fieldTreeId
 * @param data
 * @returns {Promise<*>}
 */
const postAssign = (fieldId, fieldTreeId, data) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(
      `/fields/${fieldId}/field_trees/${fieldTreeId}/field_tree_workers/assign`
    ),
    data,
  });
};

/**
 * 作業員を現場から除外する
 * @param fieldId
 * @param fieldTreeId
 * @param data
 * @returns {Promise<*>}
 */
const deleteAssign = (fieldId, fieldTreeId, data) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(
      `/fields/${fieldId}/field_trees/${fieldTreeId}/field_tree_workers/unassign`
    ),
    data,
  });
};

/**
 * 施工体系作業員復旧API
 * @param data
 * @returns {Promise<*>}
 */
const active = data => {
  return requestWithToken({
    method: 'PATCH',
    url: '/api/private/field_tree_worker/active',
    data,
  });
};

/**
 * 施工体系作業員停止API
 * @param data
 * @returns {Promise<*>}
 */
const inactive = data => {
  return requestWithToken({
    method: 'PATCH',
    url: '/api/private/field_tree_worker/inactive',
    data,
  });
};

/**
 * 施工体制作業員業務更新API
 * @param fieldId: 現場ID
 * @param fieldTreeId: 施工体系ID
 * @param param: リクエストパラメーター
 * @returns {Promise<*>}
 */
const updateJobAndPosition = (fieldId, fieldTreeId, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: `/api/private/fields/${fieldId}/field_trees/${fieldTreeId}/field_tree_worker_duties`,
    data: param,
  });
};

export const FieldTreeWorkersApi = {
  getUnassignedWorker,
  getAssignedWorker,
  postAssign,
  deleteAssign,
  fetchWorkerInfo,
  active,
  inactive,
  updateJobAndPosition,
};

export default FieldTreeWorkersApi;



// WEBPACK FOOTER //
// ./src/services/fieldTreeWorkers/FieldTreeWorkersApi.js